export default __webpack_public_path__ + "static/media/iosIcon.9dc70d6e.svg";